<template>
  <div class="PC_home">
    <div class="bg">
      <img src="@/assets/background.svg" />
    </div>
    <div class="main">
      <!-- 标题 -->
      <div class="title">
        <img src="@/assets/henu_app.svg" />
      </div>
      <div class="content">
        <!-- 搜索 -->
        <div class="searchBG">
          <div class="search">
            <input
              type="text"
              class="searchCTE"
              placeholder="请在此输入要办事项的关键字"
              v-model="searchCTN"
              @keydown.enter="search()"
            />
            <div class="searchBTN" @click="search()">
              <img src="@/assets/search.svg" />
              <div>搜索</div>
            </div>
          </div>
        </div>
        <div class="chooseBOX">
          <div class="item item1" @click="changePage(1)">
            <div class="itemPIC">
              <div class="itemPicBox itemPicBox1"></div>
            </div>
            <div class="itemTXT">学 生</div>
          </div>
          <div class="item item2" @click="changePage(2)">
            <div class="itemPIC">
              <div class="itemPicBox itemPicBox2"></div>
            </div>
            <div class="itemTXT">教 师</div>
          </div>
          <div class="item item3" @click="changePage(3)">
            <div class="itemPIC">
              <div class="itemPicBox itemPicBox3"></div>
            </div>
            <div class="itemTXT">管理人员</div>
          </div>
          <div class="item item4" @click="changePage(4)">
            <div class="itemPIC">
              <div class="itemPicBox itemPicBox4"></div>
            </div>
            <div class="itemTXT">毕业校友</div>
          </div>
        </div>
      </div>
      <div class="bottom" :style="elementStyle">
        版权所有 © 2021 河南大学教务处
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "pc_home",
  data() {
    return {
      searchCTN: "",
      elementStyle: {
        top:'1027px',
        bottom:'',
        left:'0',
        position: 'absolute',
        width: '100%',

        height: '21px',
        fontWeight: 400,
        fontSize: '14px',
        color: '#666666',
        lineHeight: '21px',
        textAlign: 'center',
        fontStyle: 'normal',
        textTransform: 'none',
      },
    };
  },
  methods: {
    updateElementPosition() {
      console.log(window.innerHeight);
      if (window.innerHeight > 1080) {
        this.elementStyle.bottom = "32px";
        this.elementStyle.top = ""; // 清空 top 样式
      } else {
        this.elementStyle.top = "1027px";
        this.elementStyle.bottom = ""; // 清空 bottom 样式
      }
      console.log(this.elementStyle.top);
    },
    ahahah: function () {
      console.log("123");
      axios({
        methods: "get",
        url: "https://jwgf.henu.edu.cn:443/user/login/wang/12345/1",
      }).then((res) => console.log(res.data));
    },
    changePage: function (page) {
      switch (page) {
        case 1:
          this.$router.push({
            path: "./pc_obj",
            name: "pc_obj",
            params: {
              msg: 10,
            },
          });
          break;
        case 2:
          this.$router.push({
            path: "./pc_obj",
            name: "pc_obj",
            params: {
              msg: 11,
            },
          });
          break;
        case 3:
          this.$router.push({
            path: "./pc_obj",
            name: "pc_obj",
            params: {
              msg: 12,
            },
          });
          break;
        case 4:
          this.$router.push({
            path: "./pc_obj",
            name: "pc_obj",
            params: {
              msg: 13,
            },
          });
          break;
      }
    },
    search: function () {
      console.log("点击了搜索");
      console.log(this.searchCTN);
      if (!this.searchCTN) {
        alert("请输入要搜索的内容");
      } else {
        // this.$router.push("./search");
        this.$router.push({
          path: "./pc_search",
          name: "pc_search",
          params: {
            msg: this.searchCTN,
          },
        });
      }
    },
  },
  mounted() {
    this.updateElementPosition(); // 初始化设置
    window.addEventListener("resize", this.updateElementPosition); // 监听窗口大小变化
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateElementPosition); // 清理事件监听器
  },
};
</script>

<style scoped>
.PC_home {
  /* position: relative; */
  width: 100%;
  height: 100%;
  background: #f6f9ff;
  border-radius: 0px 0px 0px 0px;
  align-items: center;
}

.bg {
  position: absolute;
  left: 0px;
  top: 0px;
  width: 100%;
  height: auto;
}
.bg img {
  width: 100%;
  height: auto;
}
.main {
  background-color: #f6f9ff;
}

.title {
  position: absolute;
  left: 0;
  top: 12%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: auto;
  width: 100%;
}
.content {
  position: absolute;
  top: 25%;
  left: 0%;
  display: flex;
  align-items: center;
  flex-direction: column; /* 设置子元素上下排列 */
  justify-content: center;
  height: auto;
  width: 100%;

}
.searchBG {
  width: 1440px;
  height: 156px;
  border-radius: 4px 4px 4px 4px;
  background: linear-gradient(
    to bottom,
    rgba(204, 227, 255, 0.59),
    rgba(167, 199, 239, 1)
  );
  display: flex;
  justify-content: center;
  align-items: center;
}

.search {
  width: 1034px;
  height: 64px;
  background: #ffffff;
  border-radius: 4px 4px 4px 4px;
  align-items: center;
  display: flex;
  position: relative;
}

.searchCTE {
  margin-left: 32px;
  font-family: Source Han Sans CN, Source Han Sans CN;
  width: 80%;

  font-size: 24px;
  line-height: 36px;
  text-align: left;
  text-transform: none;
  font-style: normal;
  /* 字体大小 */
  border: none;
}

.searchBTN {
  width: 160px;
  height: 56px;
  position: absolute;
  left: 870px;
  background: #00589f;
  border-radius: 4px 4px 4px 4px;
  color: #fff;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.searchBTN img {
  margin-left: 40px;
}

.searchBTN div {
  width: 48px;
  height: 36px;
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 400;
  font-size: 24px;
  margin-left: 6px;
  color: #ffffff;
  line-height: 36px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}
.searchBTN:hover {
  cursor: pointer;
  font-size: 25px;
}

/* .chooseBOX {
  height: 384px;
  position: relative;
} */
.chooseBOX {
  display: flex;
  justify-content: space-around; /* 子项水平间隔 */
  margin-top: 44px; /* 设置与上面搜索框的间距 */
}
.item {
  float: left;
  width: 336px;
  height: 156px;
  display: flex;
  align-items: center;
  flex-direction: column; /* 设置子元素上下排列 */
  justify-content: center;
  background: linear-gradient(135deg, #f1f7fd 0%, #dfedf9 100%);
  border-radius: 4px 4px 0px 0px;
}
.item:not(:last-child) {
  margin-right: 30px; /* 除最后一个元素外的右边距 */
}

.item:hover {
  cursor: pointer;
}

.itemTXT {
  margin: 10px;
  height: 33px;
  font-weight: 500;
  font-size: 22px;
  font-size: 30px;
  color: #00589f;
  line-height: 33px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.itemPicBox {
  width: 48px;
  height: 48px;
}
.itemPicBox1 {
  background: url("../../assets/stu1.svg");
}
.itemPicBox2 {
  background: url("../../assets/tea1.svg");
}

.itemPicBox3 {
  background: url("../../assets/adm1.svg");
}

.itemPicBox4 {
  background: url("../../assets/fre1.svg");
}
.bottom {
  position: absolute;
  left: 856px;
  width: 209px;
  height: 21px;
  font-weight: 400;
  font-size: 14px;
  color: #666666;
  line-height: 21px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}
</style>
